import { ref, watch, computed } from '@vue/composition-api'
import popups from '@/hooks/popups';
import i18n from "@/libs/i18n";
import store from "@/store";

export default function cashListQuery() {
    const { errorToast } = popups()
    const perPageOptions = [10, 25, 50, 100]
    const isSortDirDesc = ref(true)
    const groupFilter = ref(null)
    const groupOptions = ref([])
    const searchQuery = ref('')
    const cashTable = ref(null)
    const currentPage = ref(1)
    const sortBy = ref('id')
    const totalCash = ref(0)
    const perPage = ref(10)
    const tableColumns = ref([
        { key: 'name', label: i18n.t('Name'), sortable: true },
        { key: groupOptions.value.length > 1 ?  'group' : '', label: i18n.t('Groups'), sortable: true },
        { key: 'total', label: 'Último cierre', sortable: true },
        { key: 'balance', label: 'Saldo', sortable: true },
        { key: 'actions', label: i18n.t('Actions') }
    ])

    const dataMeta = computed(() => {
        const localItemsCount = cashTable.value ? cashTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalCash.value,
        }
    });

    const refetchData = function() {
        cashTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, groupFilter], () => {
        refetchData()
    })

    const fetchCash = function(ctx, callback) {
        store.dispatch('cashes/fetchCashes', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            group: groupFilter.value,
        })
        .then(response => {
            const { cashes, groups, total } = response.data
            callback(cashes)
            groupOptions.value = groups
            tableColumns.value = [
                { key: 'name', label: i18n.t('Name'), sortable: true },
                { key: groupOptions.value.length > 1 ?  'group' : '', label: i18n.t('Groups'), sortable: true },
                { key: 'total', label: 'Último cierre', sortable: true },
                { key: 'balance', label: 'Saldo', sortable: true },
                { key: 'actions', label: i18n.t('Actions') }
            ]
            totalCash.value = total
        })
        .catch(() => { errorToast("Error fetching cash list") })
    }

    return {
        fetchCash,
        tableColumns,
        perPage,
        currentPage,
        totalCash,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        cashTable,
        refetchData,
        groupFilter,
        groupOptions
    }
}
